import UploadReport from "../pages/UploadReport";

const authProtectedRoutes = [
  { path: "/upload-report", component: UploadReport },
]

export { authProtectedRoutes }